export default {
  countCells: 25,
  massive: [
    {
      dataField: 'actions',
      cols: 1,
      rows: 2,
      text: '',
      class: 'd-flex flex-row align-center justify-center ',
      order: 0,
      variable: true,
    },
    {
      dataField: 'org',
      cols: 6,
      rows: 2,
      text: 'Организация',
      class: 'd-flex flex-row align-center justify-start ',
      headerStyles: `min-width: 350px;`,
      order: 0,
      variable: true,
    },
    {
      dataField: 'npg',
      cols: 6,
      rows: 2,
      headerClass: 'd-flex flex-row justify-start pa-0 font-size-small__important',
      headerStyles: `min-width: 350px;`,
      class: 'justify-start d-flex flex-row',
      text: 'Код и наименование УГСН (НПС), группы научных специальностей',
      html: 'Код и наименование<br> УГСН (НПС), группы научных специальностей',
      order: 6,
      variable: true,
    },
    {
      dataField: 'hasAccred',
      cols: 1,
      rows: 2,
      text: `Наличие гос. аккредитации`,
      order: 7,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      class: 'd-flex flex-row align-center justify-center ',
      styles: 'justify-content: unset; text-align: center; text-align: center;',
    },
    {
      dataField: 'hasLicense',
      cols: 1,
      rows: 2,
      text: `Наличие лицензии`,
      order: 7,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      class: 'd-flex flex-row align-center justify-center ',
      styles: 'justify-content: unset; text-align: center; text-align: center;',
    },
    {
      dataField: 'npg11',
      cols: 3,
      rows: 1,
      headerClass: 'text-center border-bottom-zero',
      text: 'минимальные значения на 2025/2026 учебный год',
      order: 1,
      variable: false,
    },
    {
      dataField: 'npg16',
      cols: 3,
      rows: 1,
      headerClass: 'text-center border-bottom-zero',
      text: 'максимальные значения на 2025/2026 учебный год',
      order: 1,
      variable: false,
    },
    {
      dataField: 'clll',
      cols: 3,
      rows: 1,
      headerClass: 'text-center border-bottom-zero',
      text: 'Выделенные КЦП в прошлые года',
      order: 1,
      headerStyles: `min-width: 150px;`,
      variable: false,
    },
    {
      dataField: 'hasGa2019',
      cols: 1,
      rows: 2,
      text: `Наличие аккредитации в прошлые года`,
      order: 100,
      headerClass: 'pa-0 font-size-small__important',
      headerStyles: 'min-width: 120px;',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qminO',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 8,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qminV',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 9,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qminZ',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 10,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qmaxO',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 11,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qmaxV',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 12,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qmaxZ',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 13,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'kcpList',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 14,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'kcpList1',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 15,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'kcpList2',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 17,
      headerClass: 'pa-0 font-size-small__important',
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
  ]
}